import { render, staticRenderFns } from "./Herhalingen.vue?vue&type=template&id=34a20c55"
import script from "./Herhalingen.vue?vue&type=script&lang=js"
export * from "./Herhalingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports